import { createContext } from "react"

import useAuth from "../hooks/useAuth"

const Context = createContext()

function UserProvider({ children }) {
    const { authenticated, userName, register, login, logout, resendVerification, forgotPassword, resetPassword } = useAuth()

    return <Context.Provider value={{ authenticated, userName, register, login, logout, resendVerification, forgotPassword, resetPassword }}>{children}</Context.Provider>
}

export { Context, UserProvider }
